import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from '../ui/card';
import { Button } from '../ui/button';
import { Shield } from 'lucide-react';
import LoaderOverlay from '../common/LoaderOverlay';

interface DataPrivacyProps {
  isDeleting: boolean;
  isDownloading: boolean;
  onRequestData: () => void;
  onDeleteAccount: () => void;
}

const DataPrivacy = ({
  isDeleting,
  isDownloading,
  onRequestData,
  onDeleteAccount,
}: DataPrivacyProps) => {
  return (
    <LoaderOverlay
      isLoading={isDeleting || isDownloading}
      loadingText={isDeleting ? 'Deleting...' : 'Downloading...'}
    >
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center space-x-2 text-base sm:text-lg">
            <Shield className="h-5 w-5 flex-shrink-0" />
            <span>Data & Privacy</span>
          </CardTitle>
          <CardDescription>
            Manage your data and privacy settings
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-4">
            <div className="p-4 border rounded-lg">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-2 gap-2">
                <h4 className="text-sm font-medium">Download Your Data</h4>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={onRequestData}
                  disabled={isDownloading}
                >
                  Request
                </Button>
              </div>
              <p className="text-xs text-muted-foreground">
                Get a copy of all your personal data and trading history
              </p>
            </div>
            <div className="p-4 border border-red-200 rounded-lg">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-2 gap-2">
                <h4 className="text-sm font-medium text-red-600">
                  Delete Account
                </h4>
                <Button
                  variant="destructive"
                  size="sm"
                  onClick={onDeleteAccount}
                  disabled={isDeleting}
                >
                  Delete
                </Button>
              </div>
              <p className="text-xs text-muted-foreground">
                Permanently delete your account and all associated data
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </LoaderOverlay>
  );
};

export default DataPrivacy;
